<template>
       <vs-popup class="document_modal document_modal-v2 expand paf_temp" :active.sync="showTemplate">
            <div class="custom_close" @click="hideMe()">
                <figure class="close_icon" @click="hideMe()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 20 20"><path class="a" d="M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm4.3,12.708L12.705,14.3A36.72,36.72,0,0,0,10,11.6a37.242,37.242,0,0,0-2.706,2.7L5.7,12.708A31.208,31.208,0,0,0,8.4,10,30.784,30.784,0,0,0,5.7,7.3L7.292,5.7s2.541,2.7,2.706,2.7,2.708-2.7,2.708-2.7L14.3,7.3A36.62,36.62,0,0,0,11.591,10C11.591,10.183,14.3,12.708,14.3,12.708Z"/></svg>
                </figure>
            </div>
            <div class="pdf_loader">
                <div class="pdf" style="height: 90vh">
                    <iframe  style="border: 0px" :src="templateUrl" height="100%"  width="100%"></iframe>
                </div>
            </div>
        </vs-popup>
        <!-- @load="onIframeLoad" -->
</template>
<script>
export default {
    components:{

    },
    provide() {
        return {
            parentValidator: this.$validator,
        };
    },
    data: () => ({
        showTemplate:false,
    }),
    props:{
        templateUrl:{
            type:String,
            default:''
        }
    },
    methods:{
        hideMe(){
            window.removeEventListener("message", this.templateMessage, false);
            this.showTemplate = false;
            this.$emit('hideTemplate')
        },
        // onIframeLoad() {
        //     console.log('onIframeLoad')
        //     window.addEventListener("message", this.templateMessage, false);
        // },
        // hideMe(){
        //     window.removeEventListener("message", this.templateMessage, false);
        //     this.showTemplate = false;
        //     console.log('showTemplate',this.showTemplate)
        //     this.$emit('hideTemplate')
        // },
        // templateMessage(event) {
        //     console.log(event)
        //     // if (event.origin !== "expected-origin") {
        //     //     return;
        //     // }
        //     console.log("Received message from iframe:", event.data);
        //     // Handle the callback data
        //     this.handleIframeData(event.data);
        // },
        // handleIframeData(data) {
        //     // Implement your logic to handle the data from the iframe
        //     console.log("Data from iframe:", data);
        // }
    },
    mounted(){
        if(this.templateUrl){
            this.showTemplate = true;
        }
    },
    beforeDestroy() {
        // Clean up the event listener when the component is destroyed
        window.removeEventListener("message", this.templateMessage, false);
    }
}
</script>